import CountryFlag from "@/components/relations/flag-icon";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

export function ServerLocationTile({ product }) {
	const { t } = useTranslation();
	const country = t(`country_list.${product.country_code.toUpperCase()}`);

	return (
		<Box display="flex" alignItems="center">
			<CountryFlag width={20} height={20} country_code={product.country_code} />

			<Box sx={{ opacity: 0.8 }}>
				{product.city} - {country}
			</Box>
		</Box>
	);
}
